import { Component, input, output } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { BillingEstimate } from '../../../../../../../Interfaces/api/billing.interface';

@Component({
    selector: 'app-billing-estimate-card',
    standalone: true,
    imports: [COMMON_IMPORTS],
    templateUrl: './estimate-card.component.html',
    styleUrls: ['../../billing.scss'],
})
export class BillingEstimateCardComponent {
    readonly estimate = input<BillingEstimate | null>(null);
    readonly isLoading = input<boolean>(false);
    readonly hasError = input<boolean>(false);

    readonly retry = output<void>();
}
